// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"51c1c00a","498":"8bef3ec0","703":"f33baeb6"}[chunkId] + ".chunk.js";
};